import React from "react";

const colorMap = {
  red: "#ff4d4f",
  yellow: "#ffec3d",
  green: "#48bd00",
};

const ColorDot: React.FC<{ color: keyof typeof colorMap }> = ({ color }) => (
  <span
    style={{
      width: 20,
      height: 20,
      display: "inline-block",
      borderRadius: 3,
      background: colorMap[color],
      border: "1px solid rgba(0,0,0,0.15)",
    }}
  />
);

export { ColorDot };
